module.exports = __webpack_public_path__ + "static/img/deposit1.009d4c85.png";